import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { reportsStore } from '../../store/reportsStore';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { ordersRatingStore } from '~/view/screens/OrdersRatingScreen/store/ordersRatingStore';
import { getFilterOptionsForPicker } from '~/view/screens/OrdersRatingScreen/helpers';

export const ReportsBranchPicker = observer((): JSX.Element => {
  const selectBranches = (branchOptions: IPickerOption[]) => {
    reportsStore.changeBranchSelection(branchOptions, 'branches');
  };

  const options = useMemo(() => {
    return getFilterOptionsForPicker({ availableBranches: ordersRatingStore.availableBranches, branches: reportsStore.filters.branches });
  }, [ordersRatingStore.availableBranches, reportsStore.filters.branches]);

  return (
    <Picker
      placeholder={localeStore.t('reports_all_branches_selected_placeholder')}
      emptyPlaceHolder={localeStore.t('report_select_branch_dropdown')}
      key="branches-picker"
      options={options}
      selectedOptions={reportsStore.filters.branches}
      onSelect={selectBranches}
      hideResetIcon
      searchable
      isMulti
      className="orders-rating-header__branches-picker mr-2"
    />
  );
});
